import { render, staticRenderFns } from "./TendersTable.vue?vue&type=template&id=20f34d3d&scoped=true"
import script from "./TendersTable.vue?vue&type=script&lang=js"
export * from "./TendersTable.vue?vue&type=script&lang=js"
import style0 from "./TendersTable.vue?vue&type=style&index=0&id=20f34d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f34d3d",
  null
  
)

export default component.exports